import React, { Fragment, useState, useEffect, useContext } from "react";
import { Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, H4, P, Image } from "../AbstractElements";
import OtpInput from 'react-otp-input';
import styles from './email-verify.module.css';
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../Layout/Loader";
import { useTranslation } from "react-i18next";
import logoLight from '../../src/assets/images/login/logo_white.png';
import logoDark from '../../src/assets/images/login/logo_dark.png';
import assets5 from '../../src/assets/images/login/Asset-5.png';
import coatOfArms from '../../src/assets/images/login/Coat_of_arms_of_Zimbabwe.png';
import { useLoader } from "../_helper/LoaderContext";
import { secureApiRequest } from "../Services/secureApiRequest";
import { decryptResponseData } from "../Services/decryptApiResponse";
import axiosInstance, { axiosNAKBHOInstance } from "../interceptor/intercetptor-inctence";

const ResetPassword = () => {
    const { _id: resetToken } = useParams();
    const { setLoading } = useLoader();
    const history = useNavigate();
    const { t } = useTranslation();
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [confirmPasswordError, setConfirmPasswordError] = useState("");
    const [toggleNewPassword, setToggleNewPassword] = useState(false);
    const [toggleConfirmPassword, setToggleConfirmPassword] = useState(false);
    const [otp, setOtp] = useState("");
    const [otpError, setOtpError] = useState("");
    // const OTP_RESEND_TIME = 600; // 10 minutes
    const OTP_RESEND_TIME = 60; // 10 minutes

    const [timeLeft, setTimeLeft] = useState(OTP_RESEND_TIME);
    const [canResend, setCanResend] = useState(false);

    const [containerHeight, setContainerHeight] = useState(window.innerHeight);
    useEffect(() => {
        const handleResize = () => {
            setContainerHeight(window.innerHeight);
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    // for timmer of resend otp
    useEffect(() => {
        setCanResend(false);
        setTimeLeft(OTP_RESEND_TIME);

        const interval = setInterval(() => {
            setTimeLeft(prev => {
                if (prev <= 1) {
                    clearInterval(interval);
                    setCanResend(true);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    // time format
    const formatTime = (seconds) => {
        const m = Math.floor(seconds / 60);
        const s = seconds % 60;
        return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
    };

    const handleNewPasswordChange = (e) => {
        setNewPassword(e.target.value);
        setPasswordError(""); // Clear password error when user types
    };

    const handleConfirmPasswordChange = (e) => {
        setConfirmPassword(e.target.value);
        setConfirmPasswordError(""); // Clear confirm password error when user types
    };

    const toggleNewPasswordVisibility = () => {
        setToggleNewPassword(!toggleNewPassword);
    };

    const toggleConfirmPasswordVisibility = () => {
        setToggleConfirmPassword(!toggleConfirmPassword);
    };

    const validateFields = () => {
        let isValid = true;

        if (!newPassword) {
            setPasswordError("newPasswordRequired");
            isValid = false;
        } else if (newPassword.length < 8) {
            setPasswordError("passwordLengthRequirement");
            isValid = false;
        }
        if (!confirmPassword) {
            setConfirmPasswordError("reEnterNewPassword");
            isValid = false;
        } else if (newPassword !== confirmPassword) {
            setConfirmPasswordError("passwordsDoNotMatch");
            isValid = false;
        }
        return isValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent form submission
        if (validateFields()) {
            const email = localStorage.getItem("email_reset")
            try {
                setLoading(true);
                const form_data = new FormData()
                form_data.append("password", confirmPassword)
                const response = await axiosNAKBHOInstance.post(`api/lab-user/reset-password`, form_data,
                    {
                        headers: {
                            Authorization: `Bearer ${resetToken}`,
                        },
                    }
                )

                if (response.data.success === true) {
                    localStorage.removeItem("email_reset")
                    toast.success(response.data.message, {
                        autoClose: 1000, // Display toast for 2 seconds
                        onClose: () => {
                            history(`${process.env.PUBLIC_URL}/login`);
                        }
                    });
                    setLoading(false);
                }
            } catch (error) {
                setLoading(false);
                console.error('Error fetching data:', error);
            }
        }
    };

    const resentOTP = async () => {
        if (!canResend) return;
        try {
            setLoading(true);
            const email = localStorage.getItem("email_reset")
            const form_data = new FormData();
            form_data.append("email", email)
            const response = await axiosNAKBHOInstance.post(`/api/lab-user/resend-otp`, form_data);
            const dec_data = response.data;
            if (dec_data.success === true) {
                toast.success(dec_data.message);
                // Restart timer
                setCanResend(false);
                setTimeLeft(OTP_RESEND_TIME);

                const interval = setInterval(() => {
                    setTimeLeft(prev => {
                        if (prev <= 1) {
                            clearInterval(interval);
                            setCanResend(true);
                            return 0;
                        }
                        return prev - 1;
                    });
                }, 1000);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
        finally {
            // End loading
            setLoading(false);
        }
    }

    const forgotPassword = () => {
        history(`${process.env.PUBLIC_URL}/forgot-password`);
    };

    return (
        <Fragment>
            <div className="login-page">
                <Container fluid={false} style={{ paddingTop: '1rem', paddingBottom: '0.5rem' }}>
                    <div className="card">
                        <Row>
                            <Col
                                xs="6"
                                className="b-center bg-size d-none d-md-flex flex-column"
                                style={{
                                    backgroundImage: `url(${require('../assets/images/login/login_left_img.png')})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    borderTopLeftRadius: '15px',
                                    borderBottomLeftRadius: '15px',
                                    // padding: '20px',
                                    color: '#1b255b', // Ensures text is white on the dark background
                                }}
                            >
                                <div style={{ marginLeft: "10%" }}>
                                    <Image
                                        attrImage={{
                                            className: 'login-logo-style',
                                            src: `${logoLight}`,
                                            alt: 'NAKBHO Logo',
                                        }}
                                    />
                                    <h3 style={{ fontWeight: 'bold', marginBottom: '0px' }}>CLINICDOTS</h3>
                                    <h3 style={{ fontWeight: 'bold', marginBottom: '20px' }}>HEALTHCARE</h3>
                                    <span>{t("Innovating Healthcare for India")}</span>
                                </div>
                            </Col>

                            <Col xs="12" md="6"
                                style={{
                                    backgroundImage: `url(${require('../assets/images/login/login_right_img.png')})`,
                                    backgroundSize: 'contain',
                                    backgroundPosition: 'center',
                                    borderTopRightRadius: '15px',
                                    borderBottomRightRadius: '15px',
                                    minHeight: `${containerHeight * 0.94}px`,
                                    display: 'flex',
                                    flexDirection: 'column'
                                }}>
                                <div className='login-card' style={{ flex: '1' }}>
                                    <div className="login-form-responsive">
                                        <Form className="theme-form login-form" onSubmit={handleSubmit}>
                                            {/* This image will only be visible on mobile screens */}
                                            <Image
                                                attrImage={{
                                                    className: 'login-dark-logo-style d-block d-md-none',
                                                    src: `${logoDark}`,
                                                    alt: 'NAKBHO Logo',
                                                }}
                                            />
                                            <H4><strong className="mb-3">{t("resetPassword")}</strong></H4>

                                            {/* <FormGroup style={{ marginTop: "2rem" }}>
                                                <Label className="col-form-label">{t("enterOtp")}</Label>
                                                <OtpInput
                                                    value={otp} containerStyle={{ justifyContent: 'space-around' }} inputStyle={`${styles.formControl}`}
                                                    onChange={setOtp}
                                                    numInputs={6}
                                                    shouldAutoFocus={true}
                                                    inputType={'tel'}
                                                    renderSeparator={<span>&nbsp;</span>}
                                                    renderInput={(props) => <input {...props} />}
                                                />
                                                {otpError && <div className="text-danger">{otpError}</div>}
                                            </FormGroup> */}

                                            <FormGroup>
                                                <Label className="col-form-label">{t("newPassword")}</Label>
                                                <div className="position-relative">
                                                    <Input
                                                        placeholder={t("enterNewPassword")} className="form-control pl-5" autoComplete="new-password" type={toggleNewPassword ? "text" : "password"} onChange={handleNewPasswordChange} value={newPassword}
                                                    />
                                                    <div
                                                        className="position-absolute"
                                                        style={{
                                                            right: '10px',
                                                            top: '50%',
                                                            transform: 'translateY(-50%)',
                                                            cursor: 'pointer'
                                                        }}
                                                        onClick={toggleNewPasswordVisibility}
                                                    >
                                                        <i style={{ fontSize: "x-large" }} className={`fa ${toggleNewPassword ? 'fa-eye-slash' : 'fa-eye'}`} aria-hidden="true"></i>
                                                    </div>
                                                </div>
                                                {passwordError && <div className="text-danger">{t(passwordError)}</div>}
                                            </FormGroup>
                                            <FormGroup>
                                                <Label className="col-form-label">{t("reEnterPassword")}</Label>
                                                <div className="position-relative">
                                                    <Input
                                                        className="form-control pl-5"
                                                        type={toggleConfirmPassword ? "text" : "password"}
                                                        placeholder={t("reEnterPassword")}
                                                        onChange={handleConfirmPasswordChange}
                                                        value={confirmPassword}
                                                    />
                                                    <div
                                                        className="position-absolute"
                                                        style={{
                                                            right: '10px',
                                                            top: '50%',
                                                            transform: 'translateY(-50%)',
                                                            cursor: 'pointer'
                                                        }}
                                                        onClick={toggleConfirmPasswordVisibility}
                                                    >
                                                        <i style={{ fontSize: "x-large" }} className={`fa ${toggleConfirmPassword ? 'fa-eye-slash' : 'fa-eye'}`} aria-hidden="true"></i>
                                                    </div>
                                                </div>
                                                {confirmPasswordError && <div className="text-danger">{t(confirmPasswordError)}</div>}
                                            </FormGroup>
                                            <div className="position-relative form-group mb-0">
                                                <Btn attrBtn={{ color: "primary", className: "d-block w-100 login-button" }}>{t("resetPassword")}</Btn>
                                            </div>
                                            {/* <p className="my-3 text-center">
                                                {canResend ? (
                                                    <strong
                                                        style={{ color: "#1b255b", cursor: "pointer" }}
                                                        onClick={resentOTP}
                                                    >
                                                        <u>{t("resendOtp")}</u>
                                                    </strong>
                                                ) : (
                                                    <span style={{ color: "#999" }}>
                                                        {t("resendOtp")} in {formatTime(timeLeft)}
                                                    </span>
                                                )}
                                            </p> */}

                                            {/* <p className="my-3 text-center"><strong style={{ color: "#1b255b", cursor: "pointer" }} onClick={resentOTP}><u>{t("resendOtp")}</u></strong></p> */}
                                            <p className="my-3 text-center">{t("backTo")} <strong style={{ color: "#1b255b", cursor: "pointer" }} onClick={forgotPassword}>{t("forgotPassword")}</strong></p>
                                        </Form>
                                    </div>
                                </div>
                                <div className="mx-3 display: flex; align-items: center; justify-content: center;" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <small className="my-3">
                                        {t("All rights reserved Copyright ©")} {new Date().getFullYear()} {t("CLINICDOTS HEALTHCARE.")}
                                    </small>
                                    {/* <div style={{ display: 'flex', gap: '10px' }}>
                                    <Image
                                        attrImage={{
                                            className: 'mb-4 login-footer-logo',
                                            src: `${assets5}`,
                                            alt: 'Assets 5 Logo',
                                        }}
                                    />
                                    <Image
                                        attrImage={{
                                            className: 'mb-4 login-footer-logo',
                                            src: `${coatOfArms}`,
                                            alt: 'Coat Of Arms Logo',
                                        }}
                                    />
                                </div> */}
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>
        </Fragment>
    );
};

export default ResetPassword;
